import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, ArrowDownLeft, Package, History } from "lucide-react";

const Transit = () => {
  const navigate = useNavigate();

  return (
    <div data-testid="transit-page" className="animate-fadeIn">
      {/* Header */}
      <div className="text-center mb-12">
        <h1 className="font-serif text-4xl md:text-5xl text-gray-900 mb-3">Transito</h1>
        <p className="text-gray-500 text-base">
          Gestisci ordini in entrata e in uscita
        </p>
      </div>

      {/* Action Buttons */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {/* Ordine in Uscita */}
        <button
          onClick={() => navigate("/transito/uscita")}
          data-testid="ordine-uscita-btn"
          className="action-btn-large p-8 text-left group"
        >
          <div className="flex flex-col h-full justify-between relative z-10">
            <div>
              <div className="w-14 h-14 rounded-xl bg-red-50 flex items-center justify-center mb-5 group-hover:bg-red-100 transition-colors">
                <ArrowUpRight className="w-6 h-6 text-red-500" strokeWidth={2} />
              </div>
              <h2 className="font-serif text-2xl text-gray-900 mb-2 font-semibold">Ordine in Uscita</h2>
              <p className="text-gray-500 text-sm leading-relaxed">
                Crea un ordine di profumi da richiedere al fornitore. 
                Genera un documento PDF con il riepilogo.
              </p>
            </div>
            <div className="mt-6 flex items-center gap-2 text-[#C9A227]">
              <span className="text-xs tracking-wide uppercase font-semibold">Inizia</span>
              <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
            </div>
          </div>
        </button>

        {/* Ordine in Entrata */}
        <button
          onClick={() => navigate("/transito/entrata")}
          data-testid="ordine-entrata-btn"
          className="action-btn-large p-8 text-left group"
        >
          <div className="flex flex-col h-full justify-between relative z-10">
            <div>
              <div className="w-14 h-14 rounded-xl bg-emerald-50 flex items-center justify-center mb-5 group-hover:bg-emerald-100 transition-colors">
                <ArrowDownLeft className="w-6 h-6 text-emerald-500" strokeWidth={2} />
              </div>
              <h2 className="font-serif text-2xl text-gray-900 mb-2 font-semibold">Ordine in Entrata</h2>
              <p className="text-gray-500 text-sm leading-relaxed">
                Registra i profumi arrivati dal fornitore. 
                Lo stock viene aggiornato automaticamente.
              </p>
            </div>
            <div className="mt-6 flex items-center gap-2 text-[#C9A227]">
              <span className="text-xs tracking-wide uppercase font-semibold">Inizia</span>
              <ArrowDownLeft className="w-4 h-4" strokeWidth={2} />
            </div>
          </div>
        </button>

        {/* Storico Ordini */}
        <button
          onClick={() => navigate("/transito/storico")}
          data-testid="storico-ordini-btn"
          className="action-btn-large p-8 text-left group"
        >
          <div className="flex flex-col h-full justify-between relative z-10">
            <div>
              <div className="w-14 h-14 rounded-xl bg-blue-50 flex items-center justify-center mb-5 group-hover:bg-blue-100 transition-colors">
                <History className="w-6 h-6 text-blue-500" strokeWidth={2} />
              </div>
              <h2 className="font-serif text-2xl text-gray-900 mb-2 font-semibold">Storico Ordini</h2>
              <p className="text-gray-500 text-sm leading-relaxed">
                Visualizza lo storico di tutti gli ordini 
                in entrata e in uscita effettuati.
              </p>
            </div>
            <div className="mt-6 flex items-center gap-2 text-[#C9A227]">
              <span className="text-xs tracking-wide uppercase font-semibold">Visualizza</span>
              <History className="w-4 h-4" strokeWidth={2} />
            </div>
          </div>
        </button>
      </div>

      {/* Info */}
      <div className="mt-12 text-center">
        <div className="inline-flex items-center gap-3 px-6 py-3 bg-white border border-gray-200 rounded-xl shadow-sm">
          <Package className="w-5 h-5 text-gray-400" strokeWidth={1.5} />
          <span className="text-gray-500 text-sm font-medium">
            I movimenti vengono tracciati automaticamente nell'inventario
          </span>
        </div>
      </div>
    </div>
  );
};

export default Transit;
